import React from 'react';
import PropTypes from 'prop-types';
import { NUMBER_SELECTABLE_COUNTRY } from 'constants/compare';

function CompareCountryReport(props) {
  const { data, countriesReports } = props;
  const countriesParsed = [];

  for (let i = 1; i <= NUMBER_SELECTABLE_COUNTRY; i++) {
    if (countriesReports) {
      countriesParsed[i] = countriesReports[i];
    }
  }

  const getClassName = (c, i = 0) => {
    if (c.isCategory) return `-category-data ${i > 0 ? 'top-margin' : ''}`;
    if (c.isSubCategory) return '-subcategory-data';
    return '';
  };

  const getCountriesValues = () => {
    const orderedCountries = [];

    Object.keys(countriesReports).forEach((c, i) => {
      orderedCountries[i] = countriesReports[i + 1];
    });

    return data.map((c, i) => (
      <tr key={i + 1}>
        <td className={getClassName(c, i)}>{c.name}</td>
        {orderedCountries.map((country, j) =>
          country.countryNum && c[country.countryNum] ? (
            <td key={i + j + 1} className={`country-score -country${j + 1}`}>
              <span className="compare-score">
                <span className={getClassName(c, i)}>
                  {c[country.countryNum].value}
                </span>
              </span>
            </td>
          ) : undefined
        )}
      </tr>
    ));
  };

  const getViewClass = () =>
    `view-${
      Object.keys(countriesReports).filter(
        (el) => !!countriesReports[el].countryNum
      ).length
    }`;
  return (
    data &&
    data.length ? (
      <article className={`c-report-score compare ${getViewClass()}`}>
        <div className="row">
          <div className="column small-12 medium-6">
              {props.title &&
                <h2 className="title">
                  {props.title}
                </h2>
              }
          </div>
          <div className="table column small-12 medium-10 medium-offset-1">
            <table className="c-table">
              <thead>
                <tr>
                  <th></th>
                  {countriesReports &&
                    Object.keys(countriesReports).map((key, i) => {
                      const countryClass = `country-name -country${i + 1}`;
                      return (
                       countriesReports[key] && countriesReports[key].name ? <th key={i} className={countryClass}>
                         <span>
                            {countriesReports[key] && countriesReports[key].name
                              ? countriesReports[key].name
                              : ''}
                         </span>
                         <span className="compare-literal">
                            {countriesReports[key] && countriesReports[key].name
                              ? ' score (#/100)'
                              : ''}
                         </span>
                       </th> : undefined
                      );
                    })}
                  {/* <td></td> */}
                </tr>
              </thead>
              <tbody>{getCountriesValues()}</tbody>
            </table>
          </div>
        </div>
      </article>
    ) : <div></div>
  );
}

CompareCountryReport.propTypes = {
  data: PropTypes.array,
  countriesReports: PropTypes.object,
  title: PropTypes.string
};

export default CompareCountryReport;



// WEBPACK FOOTER //
// ./app/components/common/compare-country-report/index.jsx